import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderAlphabetical'
})
export class OrderAlphabeticalPipe implements PipeTransform {

  // Private method to sort
  public sortAlphabetical(item1: string, item2: string) {
    // Build collator
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    // Compare
    return collator.compare(item1, item2);
  }

  // Transform method
  public transform(array, orderBy, asc = true): any {
    if (!orderBy || orderBy.trim() === '') return array;

    // Ascending
    if (asc) {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.sortAlphabetical(item1[orderBy], item2[orderBy]);
      });
    }
    // Descending
    else {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.sortAlphabetical(item2[orderBy], item1[orderBy]);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/order-by/order-alphabetical.pipe.ts